import type { Options } from 'highcharts';

export const chartOptions: Options = {
  title: {
    text: '',
  },
  chart: {
    backgroundColor: 'transparent',
    height: 190,
    width: 190,
    spacing: [0, 0, 0, 0],
  },
  exporting: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
    useHTML: true,
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      borderRadius: 0,
      borderWidth: 0,
      innerSize: '63%',
      size: '190px',
      showInLegend: true,
      startAngle: 180,
    },
    series: {
      dataLabels: {
        enabled: false,
      },
    },
  },
};
